import dayjs from 'dayjs';
import { Tag } from 'antd';
import { DownloadOutlined, HourglassOutlined } from '@ant-design/icons';
import React, { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';

import {
    EXPORT_TYPES,
    ExportsParams,
    ExportsProps,
    ExportType,
} from '../interface/exports.interface';
import getEnvConfig from '../../../../../utils/config/env';
import { DATE_YEAR } from '../../../../../shared/contants/date';

const renderType = (type: ExportType): string => {
    switch (type) {
        case EXPORT_TYPES.ORDERS:
            return 'Заказы';
        case EXPORT_TYPES.VISITORS:
            return 'Посетители';
        default:
            return '';
    }
};

const renderInterval = (params?: ExportsParams): string => {
    if (!params?.start_at || !params?.end_at) {
        return '';
    }

    const startDate = dayjs(params.start_at);
    const endDate = dayjs(params.end_at);

    if (!startDate.isValid() || !endDate.isValid()) {
        return '';
    }

    if (startDate.isSame(endDate, 'day')) {
        return startDate.format(DATE_YEAR);
    }

    const [start, end] = startDate.isBefore(endDate)
        ? [startDate, endDate]
        : [endDate, startDate];

    return `${start.format(DATE_YEAR)} - ${end.format(DATE_YEAR)}`;
};

const renderIcon = (record: ExportsProps) => {
    const Component: FC<PropsWithChildren> = ({ children }) => {
        const handleDownload = () => {
            const link =
                new URL(getEnvConfig().env.API_URL).origin +
                `/storage/${record.file_path}`;

            window.open(link, '_blank');
        };

        return (
            <StyledWrapper onClick={handleDownload}>{children}</StyledWrapper>
        );
    };

    const styles = {
        fontSize: '20px',
    };

    switch (record.status) {
        case 'Готов':
            return (
                <Component>
                    <DownloadOutlined
                        style={{
                            ...styles,
                            color:
                                record.status === 'Готов'
                                    ? '#6257D2'
                                    : undefined,
                        }}
                    />
                </Component>
            );
        default:
            return (
                <Component>
                    <HourglassOutlined style={styles} />
                </Component>
            );
    }
};

export const getColumns = () => [
    {
        title: 'Интервал выгрузки',
        dataIndex: 'params',
        key: 'params',
        render: (params: ExportsParams) => renderInterval(params),
    },
    {
        title: 'Таблица',
        dataIndex: 'type',
        key: 'type',
        render: type => renderType(type),
    },
    {
        title: 'Дата запроса',
        dataIndex: 'created_at',
        key: 'created_at',
        render: (created_at: Date) =>
            dayjs(created_at).format('DD.MM.YY, HH:mm'),
    },
    {
        title: 'Статус',
        dataIndex: 'status',
        key: 'status',
        render: (status: string) => <Tag>{status}</Tag>,
    },
    {
        title: '',
        dataIndex: 'file_path',
        key: 'file_path',
        render: (_, record: ExportsProps) => renderIcon(record),
    },
];

const StyledWrapper = styled.div`
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
`;
